import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'
// import { push } from 'react-router-redux'

import { api } from './api'
// import * as models from './models'
import * as actions from './actions'
// import * as selectors from './selectors'

const fetchTargets = action$ => {
  return action$.ofType(actions.fetchTargets.toString()).mergeMap(() => {
    return api
      .fetchTargets()
      .mapResponse(actions.fetchTargetsSuccess)
      .startWith(actions.fetchTargetsPending())
      .catch(error => {
        return Observable.of(actions.fetchTargetsFailed({ error }))
      })
  })
}

const updateTarget = action$ => {
  return action$.ofType(actions.updateTarget.toString())
  .pluck('payload')
  .mergeMap((payload) => {
    return api
      .patchTarget(payload.operations, payload.targetId)
      .mapResponse(actions.updateTargetSuccess)
      .startWith(actions.updateTargetPending())
      .catch(error => {
        return Observable.of(actions.updateTargetFailed({ error }))
      })
  })
}

const createTarget = action$ => {
  return action$.ofType(actions.createTarget.toString())
  .pluck('payload')
  .mergeMap((payload) => {
    return api
      .createTarget(payload)
      .mapResponse(actions.createTargetSuccess)
      .startWith(actions.createTargetPending())
      .catch(error => {
        return Observable.of(actions.createTargetFailed({ error }))
      })
  })
}

export const epic = combineEpics(fetchTargets, createTarget, updateTarget)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/targeting/epic.js